export const HELP_ARTICLE_UI_COPY_PT = {
  "onThisPage": "Nesta página",
  "jumpMessage": "Vá para a pergunta exata do fluxo de trabalho que você precisa responder antes de exportar.",
  "faq": "Perguntas frequentes",
  "by": "Por",
  "lastReviewed": "Última revisão"
};

export const COOKIE_CONSENT_COPY_PT = {
  "text": "Usamos cookies e tecnologias semelhantes para funcionalidades, análises e medição de anúncios necessárias (Google e Meta).",
  "detail": "Se você rejeitar, a análise opcional e a medição de anúncios permanecerão desativadas. Saiba mais em nosso Aviso de Privacidade.",
  "manage": "Configurações de cookies",
  "save": "Salvar preferências",
  "essentialTitle": "Cookies essenciais",
  "essentialDesc": "Necessário para segurança, login e funcionalidade principal do site.",
  "analyticsTitle": "Cookies analíticos",
  "analyticsDesc": "Ajude-nos a entender o tráfego e o uso do produto (por exemplo, Google Analytics).",
  "advertisingTitle": "Medição de Publicidade",
  "advertisingDesc": "Meça o desempenho e as conversões dos anúncios (por exemplo, Meta Pixel/CAPI).",
  "gpcNotice": "O Controle Global de Privacidade está ativado em seu navegador, portanto a medição de publicidade permanece desativada.",
  "saveError": "Não foi possível salvar suas preferências de cookies neste navegador. Verifique suas configurações de armazenamento ou privacidade e tente novamente.",
  "accept": "Aceitar tudo",
  "reject": "Rejeitar Opcional",
  "learnMore": "Aviso de privacidade"
};

export const NOT_FOUND_PAGE_COPY_PT = {
  "title": "404 | Stocktag",
  "description": "A página que você procura não foi encontrada.",
  "ariaLabel": "Página não encontrada",
  "goHome": "Vá para casa",
  "openStudio": "Abra Metadata Studio"
};

export const MOBILE_NAV_LABELS_PT = {
  "menu": "Menu",
  "metadata": "Metadados",
  "studio": "Estúdio",
  "history": "História",
  "market": "Mercado",
  "profile": "Perfil",
  "login": "Entrar",
  "navAriaLabel": "Navegação móvel"
};

export const HELP_CENTER_COPY_PT = {
  "onThisPageTitle": "Nesta página",
  "onThisPageBody": "A página de ajuda agora segue a jornada real do produto: configuração, upload, configuração de regras, revisão, exportação e histórico.",
  "overviewTitle": "A ordem certa para um usuário iniciante",
  "overviewBody": "Primeiro esclareça a configuração da conta e do crédito, depois traga os arquivos, defina regras, refine o resultado e exporte no final.",
  "overviewCards": [
    {
      "id": "prepare",
      "title": "Prepare-se",
      "body": "Confirme o plano, os créditos e a capacidade necessária."
    },
    {
      "id": "produce",
      "title": "Produzir",
      "body": "Faça upload de ativos, defina regras de metadados e restrinja a saída."
    },
    {
      "id": "deliver",
      "title": "Entregar",
      "body": "Exporte para mercados, baixe novamente do histórico e recupere rascunhos."
    }
  ],
  "flowTitle": "Fluxo de trabalho passo a passo",
  "flowBody": "Cada seção mostra a tela que você usa e as ações que você pode realizar nesse estágio.",
  "extraToolsTitle": "Ferramentas de suporte fora do fluxo principal",
  "extraToolsBody": "Estes são os módulos extras que você usa após o fluxo de trabalho principal de metadados.",
  "resultLabel": "Resultado desta etapa",
  "mediaLabel": "Telas que você verá aqui",
  "stageSetupLabel": "Configuração",
  "stageSetupTitle": "Prepare seu espaço de trabalho",
  "stageSetupSummary": "Antes da primeira sessão, confirme o status da conta e os créditos disponíveis.",
  "stageSetupResult": "Você sabe com qual plano de créditos e saldo está trabalhando.",
  "stageUploadLabel": "Carregar",
  "stageUploadTitle": "Traga arquivos para o estúdio",
  "stageUploadSummary": "Importe imagens, vetores e vídeos e inicie a sessão de trabalho.",
  "stageUploadResult": "Sua sessão está pronta e os ativos entram em um fluxo de processamento claro.",
  "stageRulesLabel": "Controle",
  "stageRulesTitle": "Definir regras de metadados",
  "stageRulesSummary": "Forme título, descrição, palavra-chave, idioma e comportamento do ativo antes da geração.",
  "stageRulesResult": "O resultado deixa de ser genérico e passa a corresponder ao seu próprio padrão de qualidade.",
  "stageReviewLabel": "Refinar",
  "stageReviewTitle": "Revise e confirme os resultados",
  "stageReviewSummary": "Edite, gere novamente e limpe os metadados gerados antes da entrega.",
  "stageReviewResult": "Você acaba com metadados de mercado mais limpos, relevantes e defensáveis.",
  "stageExportLabel": "Entregar",
  "stageExportTitle": "Exportar para mercados",
  "stageExportSummary": "Escolha formatos, aplique predefinições e produza vários resultados em uma sessão.",
  "stageExportResult": "Você sai com arquivos CSV prontos ou pacotes de metadados incorporados para cada plataforma.",
  "stageHistoryLabel": "Arquivo",
  "stageHistoryTitle": "Retorne ao histórico e recupere rascunhos",
  "stageHistorySummary": "Baixe novamente as exportações mais antigas, recupere rascunhos e mantenha o arquivo limpo.",
  "stageHistoryResult": "O trabalho anterior permanece reutilizável em vez de se perder entre as sessões.",
  "supportedFilesTitle": "Arquivos suportados",
  "supportedFilesBody": "JPG, PNG, SVG, EPS, MP4 e MOV podem ser tratados no mesmo estúdio.",
  "rulesGuardrailsTitle": "Regras e guarda-corpos",
  "rulesGuardrailsBody": "Use instruções personalizadas e palavras proibidas para manter a produção de IA dentro de limites seguros.",
  "rulesAdvancedTitle": "Idioma, modo e profundidade de IA",
  "rulesAdvancedBody": "Tradução, modos PNG/vetor/EPS e configurações de análise profunda permitem ajustar o comportamento para diferentes tipos de ativos.",
  "aiRefineTitle": "Refinamento de IA",
  "aiRefineBody": "O raciocínio, a regeneração e a análise mais profunda ajudam a fortalecer rapidamente a produção fraca.",
  "presetCardTitle": "Lógica predefinida",
  "presetCardBody": "O mesmo conjunto de metadados pode ser remodelado para diferentes expectativas do mercado.",
  "extraToolsNavLabel": "Ferramentas extras"
};

export const SUPPORT_COPY_PT = {
  "helpEyebrow": "Centro de suporte",
  "helpTitle": "Escolha o caminho mais rápido para uma resposta",
  "helpBody": "Use o assistente para obter orientação rápida, envie um e-mail para uma pessoa real para obter ajuda particular ou específica da conta e mantenha as ideias de produtos visíveis no quadro de comentários.",
  "feedbackEyebrow": "Canal certo, resposta mais rápida",
  "feedbackTitle": "Feedback e suporte têm funções diferentes",
  "feedbackBody": "Publique ideias de produtos publicamente para que outras pessoas possam participar. Envie problemas privados, de cobrança, de conta ou de bloqueio diretamente para a equipe de suporte.",
  "aiTitle": "Pergunte ao assistente de IA",
  "aiBody": "Obtenha uma resposta instantânea sobre fluxos de trabalho, configurações, exportações e créditos.",
  "aiAction": "Assistente aberto",
  "humanTitle": "Fale com uma pessoa real",
  "humanBody": "Use e-mail para questões de conta, cobrança, segurança, privadas ou não resolvidas.",
  "humanAction": "Suporte humano por e-mail",
  "feedbackCardTitle": "Compartilhe uma ideia de produto",
  "feedbackBodyCard": "Inicie uma solicitação pública, acompanhe seu status e continue a discussão.",
  "feedbackAction": "Abra o quadro de comentários",
  "helpCardTitle": "Leia a Central de Ajuda",
  "helpCardBody": "Verifique o fluxo de trabalho guiado e as respostas comuns antes de abrir uma solicitação.",
  "helpCardAction": "Abra a Central de Ajuda",
  "privacyNote": "O quadro de feedback é público. Nunca publique credenciais da conta, detalhes de pagamento, dados pessoais ou informações de contas privadas.",
  "launcherLabel": "Suporte",
  "chatbotTitle": "Suporte Stocktag",
  "chatbotStatus": "Assistente de IA · ajuda humana disponível",
  "chatbotHumanStatus": "A equipe de suporte está cuidando desta conversa",
  "chatbotHumanQueuedNotice": "Novas mensagens são salvas na fila de suporte. As respostas da equipe aparecerão aqui.",
  "chatbotAdminSender": "Equipe de suporte",
  "chatbotAiSender": "Assistente de IA",
  "humanPromptTitle": "Precisa de uma pessoa real?",
  "humanPromptBody": "Envie um e-mail para a equipe Stocktag e inclua o contexto atual do bate-papo em seu rascunho.",
  "chatbotHumanAction": "Suporte por e-mail",
  "chatbotFeedbackAction": "Compartilhe comentários",
  "chatbotHelpAction": "Central de Ajuda",
  "chatbotFooterNote": "Os bate-papos ficam visíveis para a equipe de suporte autorizada, que pode responder aqui quando necessário.",
  "chatbotPrivacyNotice": "As mensagens de bate-papo são armazenadas nos servidores Stocktag e podem ser revisadas e respondidas pela equipe de suporte autorizada. Não compartilhe senhas, credenciais da conta, detalhes de cartões ou dados pessoais confidenciais.",
  "chatbotPrivacyAction": "Privacidade",
  "chatbotSources": "Respostas verificadas relacionadas",
  "chatbotResolvedPrompt": "Isso resolveu o problema?",
  "chatbotResolvedYes": "Sim, resolvido",
  "chatbotResolvedNo": "Não, continue o diagnóstico",
  "chatbotResolvedThanks": "Obrigado – resolução anotada.",
  "chatbotContinuing": "Continuando com a próxima etapa de diagnóstico…",
  "chatPromptHelp": "Ajude-me a escolher o fluxo de trabalho Stocktag correto para minha pergunta.",
  "chatPromptFeedback": "Ajude-me a transformar minha ideia de produto em um feedback claro e útil.",
  "emailSubject": "Solicitação de suporte Stocktag",
  "emailIntro": "Gostaria da ajuda da equipe de suporte Stocktag.",
  "emailSummary": "Por favor me ajude com o pedido abaixo.",
  "escalationSubject": "Suporte Stocktag - Escalação de bate-papo",
  "escalationIntro": "Comecei com o assistente Stocktag AI e agora gostaria da ajuda de uma pessoa real.",
  "escalationSummary": "Continue esta solicitação de suporte.",
  "bugNoticeTitle": "Este bloqueio funciona ou está relacionado à sua conta?",
  "bugNoticeBody": "Para problemas urgentes, privados, de cobrança ou de conta, envie também suporte por e-mail. Não publique detalhes confidenciais publicamente.",
  "bugNoticeAction": "Suporte humano por e-mail",
  "socialTitle": "Páginas sociais oficiais do Stocktag",
  "socialBody": "Use estas páginas para anúncios e contato público. Em vez disso, envie contexto privado de conta, cobrança, segurança ou pagamento por e-mail."
};


export default HELP_CENTER_COPY_PT;
